import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '../redux/connect';
import { getIframeUrl, getIframeTitle } from '../redux/selectors';
import { closeIframeModal } from '../redux/actions';
import { IFrameModal } from '@adsk/bim360-matrix-react-components';

const POPUP_VIEWER_URL = 'popupViewerUrl';
const POPUP_VIEWER_TITLE = 'popupViewerTitle';

export const PureControllableIFrameModal = ({ closeIframe, iframeUrl, iframeTitle }) => {
  const routerMock = {
    push: () => {
      closeIframe();
    },
    location: {
      pathname: '',
    },
  };

  const getLocationMock = () => {
    if (iframeUrl) {
      return {
        query: {
          [POPUP_VIEWER_URL]: iframeUrl,
          [POPUP_VIEWER_TITLE]: iframeTitle,
        },
      };
    }
    return {};
  };

  return <IFrameModal
    router={routerMock}
    location={getLocationMock()}
    iframeSourceUrlParameter={POPUP_VIEWER_URL}
    iframeTitleUrlParameter={POPUP_VIEWER_TITLE}
  />;

};

PureControllableIFrameModal.displayName = 'ControllableIFrameModal';

PureControllableIFrameModal.propTypes = {
  closeIframe: PropTypes.func.isRequired,
  iframeUrl: PropTypes.string,
  iframeTitle: PropTypes.string,
};

const mapStateToProps = state => ({
  iframeUrl: getIframeUrl(state),
  iframeTitle: getIframeTitle(state),
});

const mapDispatchToProps = {
  closeIframe: closeIframeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PureControllableIFrameModal);

